/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Abilities_Implied_HintInputs */



/**
* | output |
* | --- |
* | "The tool behind the deliverable you picked is always available and is not listed here." |
*
* @param {Agent_Builder_Abilities_Implied_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_abilities_implied_hint = /** @type {((inputs?: Agent_Builder_Abilities_Implied_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Abilities_Implied_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Werkzeug für das gewählte Ergebnis steht immer zur Verfügung und wird hier nicht aufgeführt.")
	return /** @type {LocalizedString} */ ("The tool behind the deliverable you picked is always available and is not listed here.")
});